<script>
  import { onMount } from 'svelte';
  import { strip_tags } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/sanitize.js?1733898724607';
  import { clerk } from '/srv/web/wyvr/html/releases/58819/gen/client/clerk/store/clerk.js?1733898724607';
  import Search from '/srv/web/wyvr/html/releases/58819/gen/client/shop/header/Search.svelte?1733898724607';

  wyvr: {
    render: "hydrate";
    loading: "instant";
  }

  export let api_token;
  export let facet_top;
  export let facet_main;
  export let store;

  let state = "busy";

  const main_titles = JSON.stringify({
    categories: "Kategorien",
    brand: "Marken",
  });
  const top_titles = JSON.stringify({
    brand: "Marke",
    categories: "Kategorien",
    color: "Farbe",
    price: "Preis",
    on_sale: "Aktion",
    product_type: "Produkttyp",
    series: "Serie",
    sizeindex: "Größe",
  });
  const main_attributes = JSON.stringify(["categories", "brand"]);
  const top_attributes = JSON.stringify([
    "brand",
    "categories",
    "color",
    "price",
    "on_sale",
    "series",
    "sizeindex",
  ]);

  let term = "";
  let mounted = false;
  onMount(() => {
    term = strip_tags(new URLSearchParams(window.location.search).get("q"));
    clerk.load(api_token);
    clerk.subscribe((loaded) => {
      if (loaded) {
        state = "idle";
      }
    });
          });
</script>

<div class="clerk-page-width" v-if="isActive">
  <div class="clerk-search-page-container">
    <div class="clerk-search-header">
      <h2>{window.__("search.search_results_for", { term })}</h2>
      <Search store={store.key} />
    </div>
    <div id="clerk-facets-container">
      <div id="clerk-search-filters" />
    </div>
    <div id="clerk-facets-container-top">
      <div id="clerk-search-filters-top" />
    </div>
    <ul id="clerk-search-results" />
  </div>

  <span
    id="clerk-search"
    class="clerk"
    data-template="@search-page"
    data-query={term}
    data-facets-design={facet_main}
    data-target="#clerk-search-results"
    data-facets-target="#clerk-search-filters"
    data-facets-attributes={main_attributes}
    data-facets-titles={main_titles}
    data-facets-price-prepend="€"
    data-facets-in-url="true"
    data-facets-view-more-text="View More"
    data-facets-searchbox-text="Search for "
  />

  <span
    id="clerk-search-top"
    class="clerk"
    data-template="@search-page"
    data-query={term}
    data-facets-design={facet_top}
    data-target="#clerk-search-results"
    data-facets-target="#clerk-search-filters-top"
    data-facets-attributes={top_attributes}
    data-facets-titles={top_titles}
    data-facets-price-prepend="€"
    data-facets-in-url="true"
    data-facets-view-more-text="View More"
    data-facets-searchbox-text="Search for "
  />
</div>


<style>
  :global(.m-searchbar) {
    flex: auto;
  }
  @media (min-width: 768px) {
    :global(input[id="search"]) {
      width: 350px;
    }
  }
</style>